// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import media from 'assets/styles/query';
import styled from 'styled-components';

export const Footer = styled.footer`
  display: none;
  visibility: hidden;
  opacity: 0;

  ${media.lessThan('small')`
    display: unset;
    visibility: visible;
    opacity: 1;

    position: fixed;
    bottom: 1.2em;
    left: 50%;
    transform: translateX(-50%);
    z-index: 998;
    overflow: hidden;

    max-width: 400px;
    width: calc(100% - 28px);
    height: 63px;
    flex-shrink: 0;

    border-radius: 20px;
    border: 1.2px solid #343434;
    background: rgba(44, 44, 44, 0.4);
    backdrop-filter: blur(75px);

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    p {
      color: rgba(255, 255, 255, 0.4);
      font-family: SF Pro Display;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.32px;
      transition: 0.3s ease-in-out;

      b {
        color: #fff;
        font-family: SF Pro Display;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.32px;
      }
    }

    svg {
      opacity: 0.4;
    }

    button {
      border-radius: 10px;
      border: 1.2px solid #414141;
      background: #1A1A1A;
      backdrop-filter: blur(13.5px);
      padding: 8px 20px;

      span {
        display: block;
        color: #FFF;
        font-family: 'SF Pro Display';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.32px;
        margin-top: -2px;
      }
    }
  `}
`;
